export default "__VITE_ASSET__BdOLN$pp__"